import {makeObservable, observable} from "mobx";
import SaporeForm from "../../forms/SaporeForm";
import EmailField from "../../forms/fields/EmailField";
import successToast from "../../components/toast/SuccessToast";
import errorToast from "../../components/toast/ErrorToast";

export class RecoverPasswordFeature {
    constructor(application) {
        this._form = this._createForm();
        this._application = application;
        makeObservable(this, {
            _form: observable,
        })
    }

    _createForm() {
        const fields = {
            "email": new EmailField(false),
        }
        return new SaporeForm(fields)
    }

    get form() {
        return this._form;
    }

    set form(value) {
        this._form = value;
    }

    emailField() {
        return this.form.getFieldByName("email")
    }

    updateEmail(value) {
        this.emailField().updateValue(value)
    }

    recoverPassword() {
        this._application.recoverPassword(this.emailField().value).then(() => {
            successToast("Se ha enviado un correo para restablecer la contraseña")
        })
        .catch((error) => {
            errorToast("No se ha podido enviar el correo de reestablecimiento de contraseña")
        });
    }
}